import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '@env/environment';
import { AuthService } from '../auth/auth.service';
import { MFA_SESSION_LOST } from '../auth/login-reason';

/**
 * Bloquea acceso a rutas protegidas si el usuario es SUPER_ADMIN
 * y aún no completó el segundo factor (TOTP).
 *
 * Aplica DESPUÉS de authGuard en la cadena de guards de la ruta /app.
 */
export const mfaGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // En modo mock no se fuerza MFA — el MockInterceptor entrega el token directo.
  if ((environment as typeof environment & { useMocks?: boolean }).useMocks) return true;

  // Solo SUPER_ADMIN requiere MFA obligatorio
  if (!auth.isSuperAdmin()) return true;

  if (auth.mfaCompleted()) return true;

  // Sólo tiene sentido mandar a la pantalla de verificación si hay un challenge
  // abierto. Antes se navegaba a /mfa siempre, y como el token viajaba en
  // `history.state` —que este navigate no setea— la pantalla rebotaba a /login en
  // su constructor: un ida y vuelta mudo que el usuario leía como "se cerró
  // sola" (FGA-163).
  if (auth.hasMfaChallenge()) {
    router.navigate(['/mfa']);
    return false;
  }

  // Sin challenge no hay nada que verificar: hay que autenticarse de nuevo. Se dice
  // por qué — el rebote sin explicación era la mitad del problema reportado.
  router.navigate(['/login'], { queryParams: { reason: MFA_SESSION_LOST } });
  return false;
};
